<nz-layout *ngIf="isAuthenticated" dir="rtl" class="app-layout">
  <nz-sider class="menu-sidebar" nzCollapsible nzWidth="256px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null" [class.sidebar-mobile]="isMobile" [class.sidebar-mobile-open]="isMobile && !isCollapsed">
    <div class="sidebar-logo">
      <img src="/assets/tktahlogo.svg" alt="logo" />
    </div>

    <!--
      The three levels are written out rather than rendered from one recursive
      <ng-template>. An ngTemplateOutlet view takes its injector from where the
      template is DECLARED, not where it is inserted, and NzMenuItemDirective
      requires NzMenuService from the enclosing `nz-menu` (and reads its nesting
      level off the parent submenu's NzSubmenuService). A shared template can
      therefore never sit in the right injector for more than one level.
      The nav tree is at most three deep, so explicit nesting costs little.
    -->
    <!--
      Never inline-collapsed on mobile. There, `isCollapsed` drives the slide-in
      drawer rather than an icon rail, and a collapsed menu switches its submenus to
      CDK overlay popups — which are attached to the body, so they kept floating over
      the page content even with the drawer itself translated off-screen.
    -->
    <ul nz-menu nzTheme="light" nzMode="inline" [nzInlineCollapsed]="isCollapsed && !isMobile">
      <li nz-menu-group nzTitle="المفضلة" *ngIf="favorites.length">
        <ul>
          <li *ngFor="let leaf of favorites" nz-menu-item nzMatchRouter [routerLink]="[leaf.route]">
            <span *ngIf="leaf.icon" nz-icon [nzType]="leaf.icon" nzTheme="outline"></span>
            <span>{{ leaf.label }}</span>
          </li>
        </ul>
      </li>

      <ng-container *ngFor="let item of nav.visibleNav">
        <li *ngIf="asLeaf(item) as leaf" nz-menu-item nzMatchRouter [routerLink]="[leaf.route]">
          <span *ngIf="leaf.icon" nz-icon [nzType]="leaf.icon" nzTheme="outline"></span>
          <span>{{ leaf.label }}</span>
        </li>

        <li *ngIf="asHub(item) as hub" nz-menu-item nzMatchRouter [routerLink]="[hub.route]">
          <span *ngIf="hub.icon" nz-icon [nzType]="hub.icon" nzTheme="outline"></span>
          <span>{{ hub.label }}</span>
        </li>

        <li *ngIf="asGroup(item) as group" nz-submenu [nzTitle]="group.label" [nzIcon]="group.icon"
          [nzOpen]="isGroupOpen(group.id)" (nzOpenChange)="setGroupOpen(group.id, $event)">
          <ul>
            <ng-container *ngFor="let child of group.children">
              <li *ngIf="asLeaf(child) as leaf" nz-menu-item nzMatchRouter [routerLink]="[leaf.route]">
                <span *ngIf="leaf.icon" nz-icon [nzType]="leaf.icon" nzTheme="outline"></span>
                <span>{{ leaf.label }}</span>
              </li>

              <li *ngIf="asHub(child) as hub" nz-menu-item nzMatchRouter [routerLink]="[hub.route]">
                <span *ngIf="hub.icon" nz-icon [nzType]="hub.icon" nzTheme="outline"></span>
                <span>{{ hub.label }}</span>
              </li>

              <li *ngIf="asGroup(child) as sub" nz-submenu [nzTitle]="sub.label" [nzIcon]="sub.icon"
                [nzOpen]="isGroupOpen(sub.id)" (nzOpenChange)="setGroupOpen(sub.id, $event)">
                <ul>
                  <ng-container *ngFor="let grandchild of sub.children">
                    <li *ngIf="asLeaf(grandchild) as leaf" nz-menu-item nzMatchRouter
                      [routerLink]="[leaf.route]">
                      <span *ngIf="leaf.icon" nz-icon [nzType]="leaf.icon" nzTheme="outline"></span>
                      <span>{{ leaf.label }}</span>
                    </li>

                    <li *ngIf="asHub(grandchild) as hub" nz-menu-item nzMatchRouter
                      [routerLink]="[hub.route]">
                      <span *ngIf="hub.icon" nz-icon [nzType]="hub.icon" nzTheme="outline"></span>
                      <span>{{ hub.label }}</span>
                    </li>
                  </ng-container>
                </ul>
              </li>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ul>
  </nz-sider>
  <div class="sidebar-backdrop" *ngIf="isMobile && !isCollapsed" (click)="isCollapsed = true"></div>
  <nz-layout>
    <nz-header>
      <div class="app-header">
        <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
          <span class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
        </span>

        <nz-breadcrumb class="header-breadcrumb" *ngIf="breadcrumb">
          <nz-breadcrumb-item *ngFor="let group of breadcrumb.path">{{ group.label }}</nz-breadcrumb-item>
          <nz-breadcrumb-item>{{ breadcrumb.leaf.label }}</nz-breadcrumb-item>
        </nz-breadcrumb>

        <span class="header-spacer"></span>

        <button type="button" class="header-search" (click)="paletteVisible = true">
          <span nz-icon nzType="search" nzTheme="outline"></span>
          <span class="header-search-label">ابحث عن صفحة</span>
          <kbd>Ctrl</kbd>
          <kbd>K</kbd>
        </button>

        <a class="header-account" nz-dropdown nzTrigger="click" [nzDropdownMenu]="accountMenu">
          <span nz-icon nzType="user" nzTheme="outline"></span>
          <span class="header-account-name" *ngIf="adminName">{{ adminName }}</span>
          <span nz-icon nzType="down" nzTheme="outline"></span>
        </a>
        <nz-dropdown-menu #accountMenu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item (click)="logout()">
              <span nz-icon nzType="logout" nzTheme="outline"></span>
              <span>تسجيل الخروج</span>
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>

<nz-layout *ngIf="!isAuthenticated">
  <nz-content>
    <div>
      <router-outlet></router-outlet>
    </div>
  </nz-content>
</nz-layout>
<app-spinner></app-spinner>

<app-command-palette *ngIf="isAuthenticated" [visible]="paletteVisible"
  (visibleChange)="paletteVisible = $event" (favoritesChanged)="refreshFavorites()"></app-command-palette>
